/*

  Implementated by Amit Sharma | Dated : 12/17/2019

*/

import React, { Fragment, useContext, useEffect, useState } from "react";
import { Row, Col, UncontrolledAlert } from 'reactstrap';
import { Field, reduxForm } from 'redux-form'
import { formatPhoneNumber } from "redux/form/format";
import { onlyNumbers } from "redux/form/normalize";
import { UpwardReduxInput, UpwardLoadingButton, FieldFileInput } from "ui";
import FormValidators from "ui/FormValidators";
import { ThemeContext } from "../../context/ThemeContext";

import { submitVerificationDocuments } from "../../services/EmployerServices";


const AccountVerificationForm = ( props ) => {
   const context = useContext( ThemeContext );
   const [ isLoading, setIsLoading ] = useState( false );
   const [ errorMessage, setErrorMessage ] = useState( "" );
   let subscription = null;

   useEffect( ()=>{
      return ( ()=>{
         if (subscription) {
            subscription.unsubscribe();
         }
      })
   },[]);

   const onFormSubmit = (formData) => {
      var submitData = new FormData();
      for (var key in formData) {
         submitData.append(key, formData[key]);
      }
      submitData.append("vt", props.vt );
      setIsLoading( true );
      subscription = submitVerificationDocuments( submitData ).subscribe(
         (responseData) => {
            if( responseData.response === "success" ){
               if( props.onSuccessfullSubmission ){
                  props.onSuccessfullSubmission();
               }
            } else {
               setErrorMessage("Try again.")
            }
            setIsLoading( false );
         }
      );
   };

   return (
      <Fragment>
         <form onSubmit={props.handleSubmit(onFormSubmit)} autoComplete="off">
            {
               errorMessage && errorMessage.length > 0 &&
               <UncontrolledAlert color="danger" className="custom-alert-failure">
                  { errorMessage }
               </UncontrolledAlert>
            }
            <Row>
               <Col xs={{ "size": 10, "offset": 1 }}>
                  <div className="form-group">
                     <Field type="text"
                        name="name"
                        placeholder="Name"
                        size="lg"
                        validate={[FormValidators.required]}
                        component={UpwardReduxInput} />
                  </div>
                  <div className="form-group">
                     <Field type="email" name="workEmail" placeholder="Work Email"
                        size="lg"
                        validate={[FormValidators.required, FormValidators.email]}
                        component={UpwardReduxInput} />
                  </div>
                  <div className="form-group">
                     <Field type="text" name="companyName" placeholder="Company Name"
                        validate={[FormValidators.required]}
                        size="lg"
                        component={UpwardReduxInput} />
                  </div>
                  <div className="form-group">
                     <Field type="text"
                        name="workPhoneNumber"
                        placeholder="Work Phone Number"
                        size="lg"
                        validate={[FormValidators.required, FormValidators.number, FormValidators.phoneNumberLength]}
                        normalize={onlyNumbers}
                        format={formatPhoneNumber}
                        component={UpwardReduxInput} />
                  </div>
                  <div className="form-group">
                     <Field
                        component={UpwardReduxInput}
                        type="textarea"
                        className="form-control"
                        size="lg"
                        row="5"
                        name="description" placeholder="Brief description of the jobs and further company details"
                        validate={[FormValidators.required]} />
                  </div>
                  <div>Validate your Company<br />Please attach one of the following.
                     <ul>
                        <li>Document of your Tax ID</li>
                        <li>Utility bill</li>
                        <li>Picture of business card</li>
                        <li>Picture of valid driver's license or ID card</li>
                     </ul>
                  </div>
                  <div className="form-group">
                     <Field
                        component={FieldFileInput}
                        type="file"
                        name="file"
                        id="verification_document"
                        size="lg"
                        validate={[FormValidators.required]}
                     />
                  </div>
               </Col>
            </Row>
            <Row className="py-2">
               <Col xs={{ "size": 10, "offset": 1 }} lg={{ "size": 6, "offset": 3 }}>
                  <UpwardLoadingButton
                     block
                     type="submit"
                     color="primary"
                     size="lg"
                     isLoading={isLoading}
                     className={"btn-rounded btn-dark-" + context}
                  >
                     <b>Continue</b>
                  </UpwardLoadingButton>
               </Col>
            </Row>
         </form>
      </Fragment>
   )
}

export default reduxForm({
   form: 'accountVerificationForm'
})(AccountVerificationForm);